import React, { Component } from 'react';
import {
  GoogleMap,
  withGoogleMap,
  withScriptjs,
} from 'react-google-maps';
import GeneralMarker from '../../pages/Dashboard/pages/RealTime/components/Map/GeneralMarker';

class Map extends Component {
  render() {
    const {
      latitude,
      longitude,
      isKeyAccount,
      shippingGroupId,
      performanceStatusCode,
      defaultZoom,
    } = this.props;

    return (
      <GoogleMap
        defaultZoom={defaultZoom || 5}
        defaultCenter={{ lat: latitude, lng: longitude }}
        defaultOptions={{
          fullscreenControl: false,
          mapTypeControl: false,
          streetViewControl: false,
        }}
      >
        <GeneralMarker
          position={{ lat: latitude, lng: longitude }}
          keyAccount={isKeyAccount}
          shippingGroupId={shippingGroupId}
          performanceStatusCode={performanceStatusCode}
        />
      </GoogleMap>
    );
  }
}

export default withScriptjs(withGoogleMap(Map));
